import {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import {
  Input,
  cn,
} from 'ui'

import { convertTextToImage } from '../../../../../utils/convertTextToImage'
import {
  SignatureHandler,
  SignatureProps,
  SignatureCard,
  SignatureToolbar,
  SignatureToolbarButton,
  SignatureClearButton,
  SignaturePlaceholder,
  SIGNATURE_PLACEHOLDER_HEIGHT,
} from './Pad'
import { signatureFonts } from './fonts'

export const WriteSignature = forwardRef<SignatureHandler, SignatureProps>(
  ({ className, width, height, ...props }, ref) => {
    const [fontIndex, setFontIndex] = useState(0)

    const font = signatureFonts[fontIndex]

    useImperativeHandle(
      ref,
      () => {
        return {
          getImage: () => {
            const inputValue = inputRef.current?.value!

            if (!inputValue) return ''

            return convertTextToImage(
              inputValue.trim(),
              font?.style?.fontFamily
            )
          },
        }
      },
      [fontIndex]
    )

    const inputRef = useRef<HTMLInputElement>(null)

    return (
      <SignatureCard
        style={{
          width: width,
          height: height
        }}
        className={className}
        isInvalid={props.error}
      >
        <SignatureToolbar>
          <SignatureToolbarButton
            onClick={() => {
              setFontIndex((fontIndex + 1) % signatureFonts.length)

              if (props.onChange) {
                props.onChange()
              }
            }}
          >
            CAMBIAR FUENTE
          </SignatureToolbarButton>
          <SignatureClearButton
            onClick={() => {
              if (inputRef.current) {
                inputRef.current.value = ''
              }
            }}
          />
        </SignatureToolbar>
        <SignaturePlaceholder>
          <Input
            maxLength={32}
            onChange={() => {
              if (props.onChange) {
                props.onChange()
              }
            }}
            style={{
              height: `${SIGNATURE_PLACEHOLDER_HEIGHT}px`,
            }}
            className={cn(font.className, 'text-[35px] placeholder:text-[24px] md:placeholder:text-[35px]')}
            size='lg'
            placeholder='Escribe tu nombre'
            ref={inputRef}
            variant='unstyled'
          />
        </SignaturePlaceholder>
      </SignatureCard>
    )
  }
)
